// src/utils/appUrls.js
const isMvp = process.env.REACT_APP_BACKEND_URL === "mvp";
const isLocal = process.env.REACT_APP_WEBSITE_ENV === "local";

export const BACKEND_BASE_URL = isMvp
  ? process.env.REACT_APP_BACKEND_NGROK_URL
  : process.env.REACT_APP_BACKEND_CLOUD_URL;

export const WEB_BASE_URL = isLocal
  ? process.env.REACT_APP_LOCAL_WEBSITE_URL
  : process.env.REACT_APP_PROD_WEBSITE_URL;
